import React from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import MicrophoneIcon from '@atlaskit/icon/core/microphone';

import { VoiceDictationResultAction } from '../effects/voiceDictationReducer';

import messages from './messages';

export const VoiceDictationButton = ({
	onStartRecording,
	onStopRecording,
	action,
}: {
	action: VoiceDictationResultAction;
	onStartRecording: () => void;
	onStopRecording: () => void;
}) => {
	const { formatMessage } = useIntl();
	const triggerRef = React.useRef<HTMLButtonElement>(null);

	const handleClick = () => {
		if (action === VoiceDictationResultAction.Recording) {
			onStopRecording();
		} else {
			onStartRecording();
		}
	};

	return (
		<IconButton
			shape="circle"
			icon={(iconProps) => <MicrophoneIcon {...iconProps} label={''} />}
			appearance="subtle"
			onClick={handleClick}
			label={formatMessage(messages.voiceDictationButtonLabel)}
			ref={triggerRef}
		/>
	);
};
